import { Checkbox } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useCanAccess } from '@mygpt/app';

import { useWidgetFormContext } from '@/components/Widget/Embed/form-context';
import { useWidgetForm } from '@/hooks/useWidgetForm';

import { SettingCard } from './SettingCard';

export const SecurityNotice = () => {
  const { t } = useTranslation();
  const { form } = useWidgetFormContext();
  const { onOverrideChangeForForm } = useWidgetForm();
  const canAccessWidgetCustomization = useCanAccess('enable_widget_customization');

  return (
    <SettingCard title={t('widget.setting.groups.card_security_notice')}>
      <Checkbox
        disabled={!canAccessWidgetCustomization}
        label={t('widget.setting.chatbot.security_notice_label')}
        checked={form.values.chatbot.securityNotice.checked}
        {...form.getInputProps('chatbot.securityNotice.checked')}
        onChange={onOverrideChangeForForm('chatbot.securityNotice.checked')}
      />
    </SettingCard>
  );
};
